import { FaCartShopping, FaLaptop, FaUser, FaWallet } from "react-icons/fa6"

export const Paths = [
  {
    path: '/',
    title: 'Home'
  },
  {
    path: '/blog',
    title: 'Blog'
  },
  {
    path: '/find',
    title: 'Find Events'
  },
  {
    path: '/about',
    title: 'About'
  },
  {
    path: '/contact',
    title: 'Contact Us'
  },
  {
    path: '/login',
    title: 'Login'
  },
  {
    path: '/signup',
    title: 'Register'
  },
  {
    path: '/create',
    title: 'Create Event'
  },
]

export const Data = [
  {
    id: 1,
    image: './pic/cov2.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Social',
    type: 'Free'
  },
  {
    id: 2,
    image: './pic/cov1.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Sports',
    type: 'Free'
  },
  {
    id: 3,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Sports',
    type: 'Free'
  },
  {
    id: 4,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Social',
    type: 'Free'
  },
  {
    id: 5,
    image: './pic/cov1.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Seminar',
    type: 'Paid'
  },
  {
    id: 6,
    image: './pic/cov2.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Seminar',
    type: 'Free'
  },
  {
    id: 7,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Music',
    type: 'Paid'
  },
  {
    id: 8,
    image: './pic/cov2.jpg',
    head: 'Shutdown Event Dinner',
    price: '3,000',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
    cat: 'Sports',
    type: 'Paid'
  },
]

export const Blo = [
  {
    id: 1,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
  {
    id: 2,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
  {
    id: 3,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
  {
    id: 4,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
  {
    id: 5,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
  {
    id: 6,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
  {
    id: 7,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
  {
    id: 8,
    image: './pic/cov.jpg',
    head: 'Shutdown Event Dinner',
    date: 'June 15, 2022',
    time: '6PM - 9PM',
  },
]

export const Comment = [
  {
    id: 1,
    name: 'John Doe',
    comment: 'This is a great event!',
    position: "Organiser"
  },
  {
    id: 2,
    name: 'John Doe',
    comment: 'This is a great event!',
    position: "Organiser"
  },
  {
    id: 3,
    name: 'John Doe',
    comment: 'This is a great event!',
    position: "Organiser"
  },
  {
    id: 4,
    name: 'John Doe',
    comment: 'This is a great event!',
    position: "Organiser"
  },
  {
    id: 5,
    name: 'John Doe',
    comment: 'This is a great event!',
    position: "Organiser"
  },
  {
    id: 6,
    name: 'John Doe',
    comment: 'This is a great event!',
    position: "Organiser"
  },
]

export const Abot = [
  {
    id: 1,
    img: <FaCartShopping />,
    title: 'Quick Instant Booking',
    desc: "Booking a ticket on Tickethub.ng is very easy and fast! It takes less than 2mins to register and you'll have your ticket sent to your email",
  },
  {
    id: 1,
    img: <FaCartShopping />,
    title: 'Secure Payment Gateway',
    desc: "All payment processors we use are fully PCI-DSS 3.0 compliant. This means that all card information is processed in a completely safe environment.",
  },
  {
    id: 3,
    img: <FaUser />,
    title: 'User-friendly Platform',
    desc: "Our platform is designed and developed with the masses at heart. It's very simple to navigate, efficient, intuitive and uses less data",
  },
  {
    id: 4,
    img: <FaLaptop />,
    title: 'Organizer Dashboard',
    desc: "As an organizer, you can manage your events from anywhere... Access real-time sales and check-in data, manage, reports etc. from any device.",
  },
  {
    id: 5,
    img: <FaWallet />,
    title: 'Request Payout Anytime',
    desc: "Payout requests can be made anytime! Once your information has been verified, you'll receive payments directly in your bank account",
  },
  {
    id: 6,
    img: <FaCartShopping />,
    title: '...and Many More',
    desc: "Yes! And a lot more other features including report export in pdf or excel, coupon management, unique QR codes for each ticket etc.",
  },
]